import { get, post } from '@/common/request';

const labelMap = new Map([
  // 标签分类
  ['classifyList', '/property/label_classifications'],
  ['addClassify', '/tenant/labelClassification/create'],
  ['editClassify', '/tenant/labelClassification/update'],
  ['deleteClassify', '/tenant/labelClassification/delete'],
  ['sort', '/tenant/labelClassification/reorder'],

  // 标签
  ['list', '/tenant/label/page'],
  ['add', '/tenant/label/create'],
  ['edit', '/tenant/label/update'],
  ['delete', '/tenant/label/delete'],
  ['preSubmit', '/tenant/labelRelation/preSubmit'],
  ['detail', '/tenant/labelRelation/page'],
  ['submit', '/tenant/labelRelation/submit'],
  ['relationList', '/tenant/labelRelation/list'],
  ['batchSubmit', '/tenant/labelRelation/batchSubmit'],
  ['tree', '/tenant/init/label/list']

]);

export interface LabelClassify {
  id?: number;
  name?:	string;
  parentId?:	null;
  remark?: string;
  sortNum?:number;
  tntResourceLabelVOList?: SearchParams[];
}

export interface SearchParams {
tenantLabelClassificationId?:	number;
name?: string
visibleMode?:	0 | 1
needReview?: 0 | 1
sortNum?: number
}

export interface LabelItem extends SearchParams {
  meta?: any;
  id?: number;
  tenantLabelClassificationName?: string;
};

interface LabelListResponce {
  totalNum?: number;
  pageNum?:	number;
  pageSize?: number;
  objectList?: LabelItem[];
  meta?: any;
}


export function getClassifys(): Promise<LabelClassify[]> {
  return get('/property/label_classifications', {}, { needHint: true });
}

export function getLabelTree(): Promise<LabelClassify[]> {
  return post('/tenant/init/label/list', {}, { proxyApi: '/resserv', needHint: true });
}

// 可管理场地的所有标签列表
export function getPlaceLabel(): Promise<LabelClassify[]> {
  return get('/tenant/place/getLabelWithPermission', {}, { proxyApi: '/resserv', needHint: true, needCancel: false });
}

export function deleteClassify(id: number) {
  return post('/tenant/labelClassification/delete', { id }, { proxyApi: '/resserv', needHint: true });
}

export function sortClassify(sorts: {id: number, index: number}[]): Promise<boolean> {
  return post('/tenant/labelClassification/reorder', { items: sorts }, { proxyApi: '/resserv', needHint: true });
}

export function getList(page: number, size: number, searchParams: SearchParams): Promise<LabelListResponce> {
  return post('/tenant/label/page', { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
}

export function editLable(values: LabelItem): Promise<boolean> {
  return post('/tenant/label/update', values, { proxyApi: '/resserv', needHint: true });
}

export function deleteLable(id: number): Promise<boolean> {
  return post('/tenant/label/delete', { id }, { proxyApi: '/resserv', needHint: true });
}

export function preSubmitLabel(resourceType: 0 | 1, labelClassificationList: any[], tntResourceId: any) {
  return post('/tenant/labelRelation/preSubmit', { resourceType, labelClassificationList, tntResourceId }, { proxyApi: '/resserv', needHint: true });
}

export function submitLabel(resourceType: 0 | 1, labelClassificationList: any[], tntResourceId: any) {
  return post('/tenant/labelRelation/submit', { resourceType, labelClassificationList, tntResourceId }, { proxyApi: '/resserv', needHint: true });
}

export function batchSubmitLabel(resourceType: 0 | 1, labelClassificationList: any[], tntResourceIdList: number[]) {
  return post('/tenant/labelRelation/batchSubmit', { resourceType, labelClassificationList, tntResourceIdList }, { proxyApi: '/resserv', needHint: true });
}

export function detail(resourceType: 0| 1, tntResourceId): Promise<LabelClassify[]> {
  return post('/tenant/labelRelation/page', { resourceType, tntResourceId }, { proxyApi: '/resserv', needHint: true });
}

export function getRelationList(resourceType: 0| 1, tntResourceId?: number): Promise<LabelClassify[]> {
  return post('/tenant/labelRelation/list', { resourceType, tntResourceId }, { proxyApi: '/resserv', needHint: true });
}

export default labelMap;

/**
 * 获取员工管辖权涉及的标签
 * https://yapi.lanhanba.com/project/399/interface/api/58477
 */

export function getSpotLabelWithPermission(params?: any) {
  return get('/tenant/spot/getLabelWithPermission', { ...params }, { proxyApi: '/resserv', needHint: true, needCancel: false });
}

